import {PotType,Pot} from './Pot'
import {Utils} from './Utils'
import * as PokerProtocol from './communication/PokerProtocol.generated'
import {ByteArrayImpl, ProtocolObject} from './communication/styx-api'
import {getStore} from './redux/Store'
import {CardPosition, ProtocolAttribute} from './communication/PokerProtocol.generated'
import { PlayerAchievementView } from './communication/PlayerApiProtocol.generated'
/**
 *
 * @type {ProtocolUtils}
 */
class ProtocolUtilsInternal {
	paramExist (key,params) {
		for (var i = 0; i < params.length; i++) {
			var object = params[i]

			if (object.key == key) {
				return true
			}
		}
		return false
	}
	fromPots (protocolPots : PokerProtocol.Pot[]) : Pot[] {
		var pots = []
		for (var i in protocolPots) {
			var p = protocolPots[i]
			var type = PotType.MAIN
			if (PokerProtocol.PotType.SIDE == p.type) {
				type = PotType.SIDE
			}
			pots.push(new Pot(p.id,type, p.amount))
		}
		return pots
	}
	readParam (key,params) {
		if (params == null) return null
		for (var i = 0; i < params.length; i++) {
			var object = params[i]

			if (object.key == key) {
				var p = null
				var valueArray =  ByteArrayImpl.fromBase64String(object.value)
				var byteArray = new ByteArrayImpl(valueArray)
				if (object.type == 1) {
					p = byteArray.readInt()
				} else {
					p = byteArray.readString()
				}
				return p
			}
		}
		return null
	}
	extractTournamentData (snapshot) {
		var params = snapshot.params
		var self = this
		var param = function(name) {
			var val = self.readParam(name,params)
			return val
		}

		const regOpen = param('REGISTRATION_OPEN')
		const isRebuyEnabled = param('REBUY_ENABLED')
		const isShovefest = param('IS_SHOVEFEST')
		const isTimedTournament = param('IS_TIMED_TOURNAMENT')
		const status = param('STATUS')
		const bountyFee = param('BOUNTY_FEE')
		const progressivePercentage = param('PROGRESSIVE_PERCENTAGE')
		const mysteryBountyFee = param('MYSTERY_BOUNTY_FEE')
		const mysteryBountyGuaranteedPrizePool = param('MYSTERY_BOUNTY_GUARANTEED_PRIZE_POOL')
		const allowsDirectBuyIn = param('ALLOWS_DIRECT_BUY_IN')

		var data : any = Object.create({
			id : snapshot.mttid,
			name : param('NAME'),
			capacity : param('CAPACITY'),
			buyIn : param('BUY_IN'),
			fee : param('FEE'),
			bountyFee : bountyFee != null ? Number(bountyFee) : null,
			mysteryBountyFee : mysteryBountyFee != null ? Number(mysteryBountyFee) : null,
			mysteryBountyGuaranteedPrizePool : mysteryBountyGuaranteedPrizePool != null ? Number(mysteryBountyGuaranteedPrizePool) : null,
			progressivePercentage : progressivePercentage != null ? Number(progressivePercentage) : null,
			status : status,
			displayStatus : this.toDisplayStatus(status),
			registered : param('REGISTERED'),
			startTime : param('START_TIME'),
			buyInCurrencyCode : param('BUY_IN_CURRENCY_CODE'),
			type: param('BETTING_GAME_BETTING_MODEL'),
			variant: param('VARIANT'),
			ruleDescription : param('RULE_DESCRIPTION'),
			registrationOpen: regOpen == null ? null : regOpen.toLowerCase() == 'true',
			category: param('CATEGORY'),
			registrationClose: param('REGISTRATION_CLOSE_TIME'),
			allowsDirectBuyIn: allowsDirectBuyIn == null ? undefined : allowsDirectBuyIn.toLowerCase() === 'true',
			isTargetTournament: false,
			isSatelliteTournament: false,
			isRebuyEnabled: isRebuyEnabled && isRebuyEnabled.toLowerCase() === 'true',
			isShovefest: isShovefest && isShovefest.toLowerCase() === 'true',
			isTimedTournament: isTimedTournament && isTimedTournament.toLowerCase() === 'true',
			reEntries: param('RE_ENTRIES') != null ? Number(param('RE_ENTRIES')) : undefined,
		})

		var isTargetTournament = param('IS_TARGET_TOURNAMENT')

		if (isTargetTournament != null && isTargetTournament.toLowerCase() == 'true') {
			var ticketsCount = parseInt(param('TARGET_TOURNAMENT_TICKET_COUNT'))
			data.isTargetTournament = true
			data.targetTickets = []
			for (let t = 0; t < ticketsCount; t++ ){
				data.targetTickets.push( {
					nameId: param('TARGET_TOURNAMENT_TICKET_NAME_ID_' + t),
					name: param('TARGET_TOURNAMENT_TICKET_NAME_' + t),
					description: param('TARGET_TOURNAMENT_TICKET_DESCRIPTION_' + t),
					imageURL: param('TARGET_TOURNAMENT_TICKET_IMAGE_' + t)
				})
			}
		}

		var isSatelliteTournament = param('IS_SATELLITE_TOURNAMENT')

		if (isSatelliteTournament != null && isSatelliteTournament.toLowerCase() == 'true') {
			data.isSatelliteTournament = true
			data.satelliteTicket= {
				nameId: param('SATELLITE_TOURNAMENT_TICKET_NAME_ID'),
				name: param('SATELLITE_TOURNAMENT_TICKET_NAME'),
				description: param('SATELLITE_TOURNAMENT_TICKET_DESCRIPTION'),
				imageURL: param('SATELLITE_TOURNAMENT_TICKET_IMAGE')
			}
		}

		const achievementsRequiredAsString = param('ACHIEVEMENTS_REQUIRED')
		if (achievementsRequiredAsString != null && achievementsRequiredAsString.trim() != '') {
			const achievementsState = getStore().getState().player.achievementState
			const achievementsRequiredAsList = achievementsRequiredAsString.split(',')

			data.locked = this.checkIfLegacyLocked(achievementsRequiredAsList, achievementsState)
			data.isUnlockableTournament = this.checkIfUnlockableTournament(achievementsRequiredAsList)

			if (param('HIDE_IF_LOCKED') != null && data.locked == true && param('HIDE_IF_LOCKED').toLowerCase() == 'true') {
				data.hideLockedTournament = true
			}
		} else {
			data.locked = null
			data.isUnlockableTournament = null
		}

		return data
	}

	checkIfLegacyLocked(achievements: string[], state) {
		for (var i = 0; i < achievements.length; i++) {
			const achievement = achievements[i]
			var achievementNameId = achievement.trim()
			if (!isAchieved(state.achievements, achievementNameId)) {
				return true
			}
		}
		return false
	}

	checkIfUnlockableTournament(achievements: string[]) {
		// 'unlocks' is the exact phrase configured to designate a tournament as unlockable in game server/dashboard
		return achievements && achievements.length === 1 && achievements[0] === 'unlocks'
	}

	checkLocked (achievementsRequired) {
		let achievements = getStore().getState().player.achievementState

		if (achievementsRequired!=null && $.trim(achievementsRequired)!='') {
			if (achievements.achievements){
				var split = achievementsRequired.split(',')
				for (var i = 0; i<split.length; i++) {
					var a = split[i]
					var achievementNameId = $.trim(a)
					if (!isAchieved(achievements.achievements, achievementNameId)) {
						return true
					}
				}
			}
		}

		return false

	}
	toDisplayStatus (status) {
		if (status == 'FINISH_REGISTRATION' || status == 'PREPARING_START') {
			return 'PREPARING'
		}
		return status
	}
	extractTableData (snapshot) {
		var params = snapshot.params
		var self = this
		var param = function(name) {
			var val = self.readParam(name,params)
			if (typeof(val)==='undefined' || val == null) {
				val = null
			}
			return val
		}
		var val = function(val) {
			if (typeof(val)!=='undefined') {
				return val
			} else {
				return null
			}
		}

		var data : any = {
			id: val(snapshot.tableid),
			name: val(snapshot.name),
			speed: param('SPEED'),
			capacity: val(snapshot.capacity),
			seated: val(snapshot.seated),
			blinds: this.getBlinds(param),
			type: param('BETTING_GAME_BETTING_MODEL'),
			tableStatus: this.getTableStatus(snapshot.seated, snapshot.capacity),
			ante: param('ANTE'),
			smallBlind: param('SMALL_BLIND'),
			bigBlind : param('BIG_BLIND'),
			showInLobby : param('VISIBLE_IN_LOBBY'),
			currencyCode : param('CURRENCY_CODE'),
			variant : param('VARIANT'),
			ruleDescription : param('RULE_DESCRIPTION'),
			flopsSeen : param('FLOPS_SEEN'),
			handsPerHour : param('HANDS_PER_HOUR'),
			averagePot : param('AVG_POT'),
			minBuyIn: param('MIN_BUY_IN'),
			maxBuyIn: param('MAX_BUY_IN'),
			surgeId: param('SURGE_ID'),
			isQuickSeatTable: param('IS_QUICK_SEAT_TABLE'),
		}

		if (param('ACHIEVEMENTS_REQUIRED')!=null) {
			data.locked = this.checkLocked(param('ACHIEVEMENTS_REQUIRED'))
		} else {
			data.locked = null
		}

		return data
	}
	getBlinds (param) {
		var sb = param('SMALL_BLIND')
		if (sb!=null) {
			return (Utils.formatCurrency(sb) + '/' + Utils.formatCurrency(param('BIG_BLIND')))
		}
		return null
	}
	getTableName (data) {
		return data.name  + ' ' + data.blinds + ' ' + data.type + ' ' + data.capacity
	}
	getTableStatus (seated, capacity) {
		if (typeof(seated)==='undefined' || typeof(capacity)==='undefined') {
			return null
		}
		if (seated == capacity) {
			return 'full'
		}
		return 'open'
	}
	fromVariantString (variantStr) {
		return this.fromVariantEnum(PokerProtocol.Variant[variantStr])
	}
	fromBetStrategyString (strat) {
		return this.fromBetStrategy(PokerProtocol.BetStrategy[strat])
	}
	getVariantShortName (id) : string {
		switch (id) {
		case PokerProtocol.Variant.TEXAS_HOLDEM:
			return 'HE'
		case PokerProtocol.Variant.TELESINA:
			return 'T'
		case PokerProtocol.Variant.CRAZY_PINEAPPLE:
			return 'CHE'
		case PokerProtocol.Variant.FIVE_CARD_STUD:
			return 'FS'
		case PokerProtocol.Variant.SEVEN_CARD_STUD:
			return 'SS'
		case PokerProtocol.Variant.OMAHA:
			return 'O'
		default: return 'N/A'
		}
	}
	getVariantAbbreviation (variant : string) : string {
		switch (PokerProtocol.Variant[variant]) {
		case PokerProtocol.Variant.TEXAS_HOLDEM:
			return 'H'
		case PokerProtocol.Variant.CRAZY_PINEAPPLE:
			return 'CP'
		case PokerProtocol.Variant.OMAHA:
			return 'O'
		case PokerProtocol.Variant.OMAHA_HL:
			return 'O8'
		default: return 'N/A'
		}
	}
	fromVariantEnum (id) {
		switch (id) {
		case PokerProtocol.Variant.TEXAS_HOLDEM:
			return i18n.t('variant.texas-holdem')
		case PokerProtocol.Variant.TELESINA:
			return i18n.t('variant.telesina')
		case PokerProtocol.Variant.CRAZY_PINEAPPLE:
			return i18n.t('variant.crazy-pineapple')
		case PokerProtocol.Variant.FIVE_CARD_STUD:
			return i18n.t('variant.five-card-stud')
		case PokerProtocol.Variant.SEVEN_CARD_STUD:
			return i18n.t('variant.seven-card-stud')
		case PokerProtocol.Variant.OMAHA:
			return i18n.t('variant.omaha')
		case PokerProtocol.Variant.OMAHA_HL:
			return i18n.t('variant.omaha-hl')
		default: return 'N/A'
		}
	}
	fromBetStrategy (id) {
		switch (id) {
		case PokerProtocol.BetStrategy.NO_LIMIT:
			return i18n.t('lobby.filters.no-limit-short')
		case PokerProtocol.BetStrategy.POT_LIMIT:
			return i18n.t('lobby.filters.pot-limit-short')
		case PokerProtocol.BetStrategy.FIXED_LIMIT:
			return i18n.t('lobby.filters.fixed-limit-short')
		default: return 'N/A'
		}
	}
	getPayloadPacket (payload : number[]) : ProtocolObject {
		if (payload.length == 0) {
			return null
		}
		var pokerData = new ByteArrayImpl(payload)
		var length = pokerData.readInt()
		var classId = pokerData.readUnsignedByte()
		var protocolObject = new PokerProtocol.ProtocolObjectFactory().create(classId, pokerData)
		return protocolObject
	}

	getType(settings) : string {
		const type = ProtocolUtils.fromVariantString(settings.variant)
		return ProtocolUtils.fromBetStrategyString(settings.betStrategyType) + ' ' + type
	}
	toPosition(pos : string) : CardPosition {
		switch (pos) {
		case 'top':
			return CardPosition.TOP
		case 'mid':
			return CardPosition.MIDDLE
		case 'bot':
			return CardPosition.BOTTOM
		default:
			return CardPosition.FOLDED
		}
	}

	getTournamentLobbyAttribute(attributes: ProtocolAttribute[], name: string): string | undefined {
		if (attributes == undefined) return
		const attribute = attributes.find(attr => attr.name === name)
		if (attribute == undefined) return
		return attribute.value
	}
}
export var ProtocolUtils = new ProtocolUtilsInternal()

export function isAchieved(achievements : PlayerAchievementView[], achievementNameId : string) {
	if (!achievements || !achievements.length) {
		return false
	}
	for (var i =0; i<achievements.length; i++) {
		var a = achievements[i]
		if (achievementNameId == a.achievementNameId) {
			if (a.achieved == true) {
				return true
			} else {
				return false
			}
		}
	}
	return false
}
